import { render } from "./DiskSectionSkeleton.vue?vue&type=template&id=956b7666"
const script = {}

import "./DiskSectionSkeleton.vue?vue&type=style&index=0&id=956b7666&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__